export enum CustomTauriEvent {
  SYSTEM_TRAY_EVENT = 'SYSTEM_TRAY_EVENT',
  UPLOAD_PROGRESS = 'UPLOAD_PROGRESS',
  UPLOAD_FINISHED = 'UPLOAD_FINISHED',
  DOWNLOAD_PROGRESS = 'DOWNLOAD_PROGRESS',
  DOWNLOAD_FINISHED = 'DOWNLOAD_FINISHED',
  GET_URL_ADDRESS = 'GET_URL_ADDRESS',
  CHANGE_URL_ADDRESS = 'CHANGE_URL_ADDRESS',
}

export enum SystemTrayEvent {
  QUIT_PROFILE = 'QUIT_PROFILE',
  STATUS_ONLINE = 'STATUS_ONLINE',
  STATUS_ABSENT = 'STATUS_ABSENT',
  STATUS_NOT_DISTURB = 'STATUS_NOT_DISTURB'
}
